/* OLIVY scroll reveal — fade-up with staggered children.
   Adds .is-visible to .olivy-reveal elements as they enter the viewport, which
   triggers the `olivy-stagger-in` keyframe on each [data-olivy-stagger] child.
   The per-child delay is passed via the --olivy-stagger-delay custom property
   (NOT transition-delay) so it never lingers on the element's own hover/focus
   transitions. On animationend each child is marked .olivy-stagger-done, which
   drops the animation so its natural styles and hover transitions apply.
   Progressive enhancement: if IntersectionObserver is unavailable, everything
   is shown immediately. */
(function () {
  function reveal(child) {
    child.classList.add('olivy-stagger-done');
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.olivy-reveal').forEach(function (el) {
      el.classList.add('is-visible');
      el.querySelectorAll('[data-olivy-stagger]').forEach(reveal);
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var children = el.querySelectorAll('[data-olivy-stagger]');
        children.forEach(function (child, i) {
          // Entrance delay drives the keyframe's animation-delay only.
          child.style.setProperty('--olivy-stagger-delay', i * 0.1 + 's');
          // Once the entrance plays, drop the animation so hover/focus work.
          child.addEventListener(
            'animationend',
            function () { reveal(child); },
            { once: true }
          );
        });
        el.classList.add('is-visible');
        obs.unobserve(el);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  function init() {
    document.querySelectorAll('.olivy-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
